import styled from 'styled-components'

export const InputContainer = styled.div`
  width: 80px;
  margin-right: var(--space-300);
`

export const ExactPositionContainer = styled.div`
  display: flex;
  align-items: center;
`

export const InputErrorContainer = styled.div`
  margin-left: var(--space-900);
`
